// socketInstance.js
import { io } from "socket.io-client";
import socketInterceptor from "../utils/socketInterceptor";

  const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";

  // Default config
  const defaultConfig = {
    autoConnect: false, // Prevent auto-connecting on import
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  };

  // Create socket instance (will be configured with interceptors before connecting)
  export const socket = io(SOCKET_URL, defaultConfig);

  // Setup response interceptors on socket events (these run automatically)
  socket.on("connect", () => {
    socketInterceptor.applyConnectInterceptor(socket);
  });

socket.on("disconnect", (reason) => {
  socketInterceptor.applyDisconnectInterceptor(reason, socket);
});

socket.on("connect_error", (error) => {
  socketInterceptor.applyErrorInterceptor(error, socket);
});
